import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { faAndroid, faApple, faFacebook, faGoogle, faInstagram, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faArrowsRotate, faArrowUpArrowDown, faBed, faBriefcase, faBuildings, faChartLineUp, faCheck, faCircle, faCircleCheck, faCircleExclamation, faCircleInfo, faCirclePause, faCirclePlay, faCircleQuestion, faCircleStop, faCircleXmark, faCity, faDoorClosed, faDoorOpen, faDownload, faEclipse, faEllipsis, faFilePlus, faFlag, faGamepad, faGear, faGlobe, faGraduationCap, faHashtag, faHeart, faHome, faHourglass, faIdCard, faImage, faKey, faLockKeyhole, faMinus, faMoneyBill, faPenToSquare, faPhone, faPhonePlus, faPhoneXmark, faPlus, faRotateRight, faSchool, faTag, faTimer, faTrash, faUser, faVial, faWallet } from "@fortawesome/pro-light-svg-icons";
export type {IconDefinition} from "@fortawesome/pro-light-svg-icons"
import "./awesome-icon.less";
import { ReactNode } from "react";

type AwesomeIconProps = FontAwesomeIconProps & {
    onClick?: (data:any) => void;
    primary?: boolean;
    success?: boolean;
    warning?: boolean;
    error?: boolean;
}

export type AwesomeStandardIconProps = Omit<AwesomeIconProps, "icon">

export const AwesomeIconOK = faCheck
export const AwesomeIconEdit = faPenToSquare
export const AwesomeIconFacebook = faFacebook
export const AwesomeIconInfo = faCircleInfo
export const AwesomeTooltipIcon = faCircleQuestion
export const AwesomeIconDelete = faTrash


const WithBtn = ({children, onClick}:{children:ReactNode, onClick?: AwesomeIconProps["onClick"]}) => onClick ? <button onClick={onClick} className="awesome-wrapper-button">{children}</button> : children;

export default function AwesomeIcon(props: AwesomeIconProps): JSX.Element {

    const {onClick, className, ...rest} = props;

    const getStateClassName = () => {
        if (props.primary) return "awesome-primary";
        if (props.success) return "awesome-success";
        if (props.warning) return "awesome-warning";
        if (props.error) return "awesome-error";
        return "";
    }

    return <WithBtn onClick={onClick}><FontAwesomeIcon fixedWidth {...rest} className={`awesome ${getStateClassName()} ${props.className || ""}`} /></WithBtn>

}



export const AwesomeOk = ({...props}:AwesomeStandardIconProps) => <FontAwesomeIcon icon={faCircleCheck} {...props} />
export const AwesomeNotOk = ({...props}:AwesomeStandardIconProps) => <FontAwesomeIcon icon={faCircleXmark} {...props} />
export const AwesomeTooltip = ({...props}:AwesomeStandardIconProps) => <FontAwesomeIcon icon={faCircleQuestion} {...props} />
export const AwesomeLoading = ({...props}:AwesomeStandardIconProps) => <FontAwesomeIcon icon={faHourglass} {...props} />
export const AwesomeInfo = ({...props}:AwesomeStandardIconProps) => <FontAwesomeIcon icon={faCircleInfo} {...props} />
export const AwesomeEdit = ({...props}:AwesomeStandardIconProps) => <FontAwesomeIcon icon={faPenToSquare} {...props} />
export const AwesomeClose = ({...props}:AwesomeStandardIconProps) => <FontAwesomeIcon icon={faCircleXmark} {...props} />
export const AwesomeMore = ({...props}:AwesomeStandardIconProps) => <FontAwesomeIcon icon={faEllipsis} {...props} />

export const AwesomeFacebook = ({...props}:AwesomeStandardIconProps) => <FontAwesomeIcon icon={faFacebook} {...props} className="awesome" fixedWidth/>
export const AwesomeGoogle = ({...props}:AwesomeStandardIconProps) => <FontAwesomeIcon icon={faGoogle} {...props} className="awesome" fixedWidth/>


